import * as React from 'react';
import { FloatingHelperAppearance, FloatingHelperSkin } from '..';

export type FloatingHelperContentActionSkin =
  | 'standard'
  | 'white'
  | 'premium'
  | 'lightPrimary'
  | 'standardPrimary';
export type FloatingHelperContentActionTheme = FloatingHelperContentActionSkin;

export type FloatingHelperContentDirection = 'horizontal' | 'vertical';

export interface FloatingHelperContentProps {
  title?: string;
  body: React.ReactNode;
  actionText?: string;
  actionSkin?: FloatingHelperContentActionSkin;
  actionTheme?: FloatingHelperContentActionSkin;
  footer?: React.ReactNode;
  onActionClick?: () => void;
  image?: React.ReactNode;
  skin?: FloatingHelperSkin;
  appearance?: FloatingHelperAppearance;
  direction?: FloatingHelperContentDirection;
}

export declare const FloatingHelperContent: React.ComponentClass<FloatingHelperContentProps>;
export default FloatingHelperContent;
